import useLocalization from '../../hooks/useLocalization';
import { Button } from '@mui/material';
import useDisplayContentConfig from '../../hooks/useDisplayContentConfig';
import useAuthForms from '../../hooks/useAuthForms';
import { SxProps, Theme } from '@mui/material';
import { mergeSx } from '../../utils/styles';
import { SKIN_CONFIGS } from '../../config/skinRegistry/configs';
import { useSkinConfigs } from '../../hooks/useSkinConfigs';

const styles = {
  modern: {
    px: { xs: 1.5, lg: 2 },
    backgroundColor: 'primary.main',
    height: { xs: '32px', lg: '52px' },
    width: { lg: '152px' },
    fontSize: { xs: '12px', lg: '14px' },
    lineHeight: { xs: 1, lg: 'normal' },
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: 'primary.700',
    },
    whiteSpace: 'nowrap',
  },
  common: {
    minWidth: { xs: '50px', md: '64px' },
    width: 'fit-content',
    lineHeight: { xs: 1, lg: 'normal' },
    padding: { xs: '0 12px', md: '0 10px' },
    height: { xs: '32px', md: '36px' },
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #fff',
    borderRadius: '18px',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 700,
    backgroundColor: 'transparent',
    '&:hover': {
      borderColor: 'info.main',
      color: 'info.main',
      backgroundColor: 'transparent',
    },
  },
};

const SignInButton = ({ sx }: { sx?: SxProps<Theme> }) => {
  const { t } = useLocalization();
  const { isModernBranding } = useDisplayContentConfig();
  const { openLoginForm } = useAuthForms();
  const { headerAuthButtonLabelKeys } = useSkinConfigs(SKIN_CONFIGS);

  const style = !isModernBranding ? styles.common : styles.modern;
  const label = t(headerAuthButtonLabelKeys.login);

  return (
    <Button sx={mergeSx(style, sx)} color='inherit' onClick={openLoginForm}>
      {label}
    </Button>
  );
};

export default SignInButton;
